var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"lilo-mark",class:_vm.size,attrs:{"src":_vm.src,"alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }